<template>
  <div>
    <b-row align-h="center">
      <div class="w-75">
        <FITFormCard>
          <div slot="header">
            <p class="h5">{{ $t('osm.serviceRequest.select.header') }}</p>
          </div>
          <div slot="formBody">
            <!-- <FITSelect :options="types" v-model="selectedType" :label="$t('osm.serviceRequest.select.type')"></FITSelect> -->
            <b-row class="py-1 my-1">
              <b-col cols="6">
                <b-card no-body :header="getHeader('policyStatus', 'fa-signal')">
                  <b-list-group v-if="policy.policyType === 'P'">
                    <b-list-group-item button @click="onClick('pau')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('pau') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('rei')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('rei') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('sur')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('sur') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('sus')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('sus') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('tro')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('tro') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('hol')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('hol') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('lap')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('lap') }}</b-list-group-item>
                  </b-list-group>
                  <b-list-group v-if="policy.policyType === 'G'">
                    <b-list-group-item button @click="onClick('gap')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('gap') }}</b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
              <b-col cols="6">
                <b-card no-body :header="getHeader('policyDetail', 'fa-file-alt')">
                  <b-list-group>
                    <b-list-group-item button @click="onClick('cbf')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cbf') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('cpb')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cpb') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'G'" @click="onClick('cga')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cga') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('cpa')" disabled class="bg-light"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cpa') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('cpm')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cpm') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('cpo')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cpo') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('cri')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cri') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('dsa')" disabled class="bg-light"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('dsa') }}</b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="py-1 my-1">
              <!-- <b-col cols="6">
                <b-card no-body :header="getHeader('agent', 'fa-user-circle')">
                  <b-list-group v-if="policy.policyType === 'P'">
                    <b-list-group-item button @click="onClick('cas')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('cas') }}</b-list-group-item>
                  </b-list-group>
                  <b-list-group v-if="policy.policyType === 'G'">
                    <b-list-group-item button @click="onClick('gas')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('gas') }}</b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col> -->
              <b-col cols="6">
                <b-card no-body :header="getHeader('policyValue', 'fa-credit-card')" v-if="policy.policyType === 'P'">
                  <b-list-group>
                    <b-list-group-item button @click="onClick('plo')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('plo') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('pse')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('pse') }}</b-list-group-item>
                    <b-list-group-item button @click="onClick('wid')"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('wid') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('mta')" disabled class="bg-light"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('mta') }}</b-list-group-item>
                    <b-list-group-item button v-if="policy.policyType === 'P'" @click="onClick('srd')" disabled class="bg-light"><i class="fa fa-angle-right mr-2"></i>{{ getLabel('srd') }}</b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
      </div>
    </b-row>
    <!-- <router-view></router-view> -->
  </div>
</template>
<script type="text/javascript">
import {
  FITSelect,
  FITFormCard
} from '@/components'

import { mapGetters } from 'vuex'

export default {
  name: 'ServiceRequest',
  components: {
    FITSelect,
    FITFormCard
  },

  data() {
    return {
      selectedType: null
    }
  },

  props: {
    policy: {
      type: Object,
      default: () => {
        return {
          policyID: 0,
          policyType: 'P'
        }
      }
    }
  },

  methods: {
    onClick(type) {
      console.debug('onClick', {
        name: `serviceRequest-${type.toLowerCase()}`,
        params: { policy: this.policy }
      })

      this.$router.push({
        name: `serviceRequest-${type.toLowerCase()}`,
        params: { policy: this.policy }
      })
    },
    getLabel(type) {
      return this.$t(`osm.serviceRequest.type.${type.toUpperCase()}.header`);
    },

    getHeader(type, icon) {
      return `<span class="h5"><i class='fa ${icon} mr-2'></i>` + this.$t(`osm.serviceRequest.select.${type}`) + '</span>';
    }
  },

  computed: {
    ...mapGetters('ServiceRequest', ['getTranslated']),

    types() {
      return this.getTranslated(this.$i18n.locale, 'serviceType')
    }
  },

  created() {
    console.debug('created');
    // this.$store
    //   .dispatch('getAllSelections', 'sr')
    //   .then((json) => {
    //     console.debug(json)
    //     this.$store.commit({ type: 'ServiceRequest/setSelections', selections: json.data });
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   })
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/containers/ServiceRequestSelect.vue